(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    

(function () {

  function initializeFinleyHeader(header) {

    if (header.dataset.finleyInitialized === 'true') {
      return;
    }

    header.dataset.finleyInitialized = 'true';

    const mobileToggle = header.querySelector(
      '[data-finley-toggle]'
    );

    const nav = header.querySelector(
      '[data-finley-nav]'
    );

    if (!mobileToggle || !nav) {
      return;
    }

    const dropdowns = Array.from(
      nav.querySelectorAll('[data-finley-dropdown]')
    );

    function closeSubmenus(dropdown) {

      dropdown.querySelectorAll(
        '[data-finley-submenu]'
      ).forEach(function (submenu) {

        submenu.classList.remove('is-open');

        const button = submenu.querySelector(
          '[data-finley-submenu-toggle]'
        );

        if (button) {
          button.setAttribute(
            'aria-expanded',
            'false'
          );
        }

      });

    }

    function setDropdown(dropdown, open) {

      dropdown.classList.toggle('is-open', open);

      const button = dropdown.querySelector(
        '[data-finley-dropdown-toggle]'
      );

      if (button) {
        button.setAttribute(
          'aria-expanded',
          String(open)
        );
      }

      if (!open) {
        closeSubmenus(dropdown);
      }

    }

    function closeAllDropdowns() {

      dropdowns.forEach(function (dropdown) {
        setDropdown(dropdown, false);
      });

    }

    function closeMobileMenu() {

      header.dataset.open = 'false';

      mobileToggle.setAttribute(
        'aria-expanded',
        'false'
      );

      closeAllDropdowns();

    }


    /* MOBILE HAMBURGER */

    mobileToggle.addEventListener(
      'click',
      function () {

        const isOpen =
          mobileToggle.getAttribute(
            'aria-expanded'
          ) === 'true';

        const nextState = !isOpen;

        mobileToggle.setAttribute(
          'aria-expanded',
          String(nextState)
        );

        header.dataset.open =
          String(nextState);

        if (!nextState) {
          closeAllDropdowns();
        }

      }
    );


    /* FIRST LEVEL DROPDOWNS */

    dropdowns.forEach(function (dropdown) {

      const button = dropdown.querySelector(
        '[data-finley-dropdown-toggle]'
      );

      if (!button) {
        return;
      }

      button.addEventListener(
        'click',
        function () {

          const shouldOpen =
            !dropdown.classList.contains('is-open');

          closeAllDropdowns();

          setDropdown(dropdown, shouldOpen);

        }
      );

    });


    /* THIRD LEVEL SUBMENUS */

    nav.querySelectorAll(
      '[data-finley-submenu]'
    ).forEach(function (submenu) {

      const button = submenu.querySelector(
        '[data-finley-submenu-toggle]'
      );

      if (!button) {
        return;
      }

      button.addEventListener(
        'click',
        function () {

          const shouldOpen =
            !submenu.classList.contains('is-open');

          const dropdown = submenu.closest(
            '[data-finley-dropdown]'
          );

          if (dropdown) {
            closeSubmenus(dropdown);
          }

          submenu.classList.toggle(
            'is-open',
            shouldOpen
          );

          button.setAttribute(
            'aria-expanded',
            String(shouldOpen)
          );

        }
      );

    });


    /* CLOSE MOBILE MENU AFTER LINK CLICK */

    nav.querySelectorAll('a').forEach(
      function (link) {

        link.addEventListener(
          'click',
          function () {
            closeMobileMenu();
          }
        );

      }
    );


    /* CLOSE DROPDOWN WHEN CLICKING OUTSIDE */

    document.addEventListener(
      'click',
      function (event) {

        if (!header.contains(event.target)) {
          closeAllDropdowns();
        }

      }
    );


    /* ESCAPE KEY SUPPORT */

    header.addEventListener(
      'keydown',
      function (event) {

        if (event.key === 'Escape') {

          closeAllDropdowns();

          if (
            mobileToggle.getAttribute(
              'aria-expanded'
            ) === 'true'
          ) {

            closeMobileMenu();
            mobileToggle.focus();

          } else {

            const brandLink = header.querySelector(
              '.finley-header__brand-link'
            );

            if (brandLink) {
              brandLink.focus();
            }

          }

        }

      }
    );

  }


  /* INITIAL PAGE LOAD */

  document.querySelectorAll(
    '[data-finley-header]'
  ).forEach(initializeFinleyHeader);


  /* SHOPIFY THEME EDITOR SUPPORT */

  document.addEventListener(
    'shopify:section:load',
    function (event) {

      event.target.querySelectorAll(
        '[data-finley-header]'
      ).forEach(initializeFinleyHeader);

    }
  );

})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  document.querySelectorAll('[data-product-thumbs]').forEach((thumbGroup) => {
    const mainImage = thumbGroup.closest('.product-page__media')?.querySelector('[data-main-image]')
    const thumbButtons = Array.from(thumbGroup.querySelectorAll('[data-thumb-button]'))

    if (!mainImage || thumbButtons.length === 0) {
      return
    }

    thumbButtons.forEach((button) => {
      button.addEventListener('click', () => {
        const imageUrl = button.dataset.imageUrl
        const imageAlt = button.dataset.imageAlt || ''

        if (!imageUrl || mainImage.getAttribute('src') === imageUrl) {
          return
        }

        mainImage.classList.add('is-loading')
        mainImage.src = imageUrl
        mainImage.alt = imageAlt

        thumbButtons.forEach((thumbButton) => {
          const isActive = thumbButton === button
          thumbButton.classList.toggle('is-active', isActive)
          thumbButton.setAttribute('aria-pressed', String(isActive))
        })
      })
    })

    mainImage.addEventListener('load', () => {
      mainImage.classList.remove('is-loading')
    })
  })

  } catch(e) { console.error(e); }
})();
})();
